export const sourcingData = [
    {
        id: "cat_branding",
        categoryTitle: "Corporate & Event Branding",
        categoryDescription: "Complete branding solutions for large-scale events, corporate identity, and awards.",
        items: [
            {
                id: "prod_trophy_01",
                title: "Trophies & Plaques",
                moq: "50 Units",
                priceRange: "₹300 - ₹5000",
                materials: ["Crystal", "Natural Wood", "Metal Casting", "Acrylic"],
                images: [
                    "https://picsum.photos/seed/trophy1/600/600",
                    "https://picsum.photos/seed/trophy2/600/600",
                    "https://picsum.photos/seed/trophy3/600/600",
                    "https://picsum.photos/seed/trophy4/600/600",
                    "https://picsum.photos/seed/trophy5/600/600",
                    "https://picsum.photos/seed/trophy6/600/600",
                ],
            },
            {
                id: "prod_medals_02",
                title: "Custom Medals",
                moq: "100 Units",
                priceRange: "₹50 - ₹500",
                materials: ["Zinc Alloy", "Brass", "Gold Plated"],
                images: [
                    "https://picsum.photos/seed/medal1/600/600",
                    "https://picsum.photos/seed/medal2/600/600",
                    "https://picsum.photos/seed/medal3/600/600",
                ],
            },
            {
                id: "prod_standees_03",
                title: "Event Standees",
                moq: "10 Units",
                priceRange: "₹1200 - ₹4500",
                materials: ["Vinyl", "Flex", "Aluminum Stand"],
                images: [
                    "https://picsum.photos/seed/standee1/600/600",
                    "https://picsum.photos/seed/standee2/600/600",
                    "https://picsum.photos/seed/standee3/600/600",
                    "https://picsum.photos/seed/standee4/600/600",
                    "https://picsum.photos/seed/standee5/600/600",
                    "https://picsum.photos/seed/standee6/600/600",
                ],
            },
            {
                id: "prod_lanyards_04",
                title: "Premium Lanyards",
                moq: "500 Units",
                priceRange: "₹20 - ₹150",
                materials: ["Satin", "Polyester", "Nylon"],
                images: [
                    "https://picsum.photos/seed/lanyard1/600/600",
                    "https://picsum.photos/seed/lanyard2/600/600",
                    "https://picsum.photos/seed/lanyard3/600/600",
                    "https://picsum.photos/seed/lanyard4/600/600",
                ],
            },
        ],
    },
    {
        id: "cat_uniforms",
        categoryTitle: "Corporate Uniforms & Apparel",
        categoryDescription: "High-quality sourcing for uniforms, corporate attire, and safety gear with extensive fabric options.",
        items: [
            {
                id: "prod_shirts_01",
                title: "Corporate Shirts",
                moq: "50 Units",
                priceRange: "₹500 - ₹1500",
                materials: ["Cotton", "Linen Blend", "Wrinkle-Free"],
                images: [
                    "https://picsum.photos/seed/shirt1/600/600",
                    "https://picsum.photos/seed/shirt2/600/600",
                    "https://picsum.photos/seed/shirt3/600/600",
                    "https://picsum.photos/seed/shirt4/600/600",
                    "https://picsum.photos/seed/shirt5/600/600",
                    "https://picsum.photos/seed/shirt6/600/600",
                    "https://picsum.photos/seed/shirt7/600/600",
                ],
            },
            {
                id: "prod_tshirts_02",
                title: "Custom T-Shirts",
                moq: "50 Units",
                priceRange: "₹300 - ₹1000",
                materials: ["Cotton", "Dry-Fit", "Polyester"],
                images: [
                    "https://picsum.photos/seed/tshirt1/600/600",
                    "https://picsum.photos/seed/tshirt2/600/600",
                    "https://picsum.photos/seed/tshirt3/600/600",
                ],
            },
            {
                id: "prod_workforce_03",
                title: "Workforce Uniforms",
                moq: "50 Units",
                priceRange: "₹500 - ₹1500",
                materials: ["Denim", "Twill", "Fire-Resistant"],
                images: [
                    "https://picsum.photos/seed/work1/600/600",
                    "https://picsum.photos/seed/work2/600/600",
                    "https://picsum.photos/seed/work3/600/600",
                    "https://picsum.photos/seed/work4/600/600",
                    "https://picsum.photos/seed/work5/600/600",
                ],
            },
            {
                id: "prod_jackets_04",
                title: "Jackets, Blazers & Kotis",
                moq: "50 Units",
                priceRange: "₹1200 - ₹5000",
                materials: ["Wool Blend", "Tweed", "Polyester"],
                images: [
                    "https://picsum.photos/seed/jacket1/600/600",
                    "https://picsum.photos/seed/jacket2/600/600",
                    "https://picsum.photos/seed/jacket3/600/600",
                    "https://picsum.photos/seed/jacket4/600/600",
                    "https://picsum.photos/seed/jacket5/600/600",
                    "https://picsum.photos/seed/jacket6/600/600",
                    "https://picsum.photos/seed/jacket7/600/600",
                    "https://picsum.photos/seed/jacket8/600/600",
                ],
            },
        ],
    },
    {
        id: "cat_gifting",
        categoryTitle: "Custom Gifting & Accessories",
        categoryDescription: "Curated corporate gifts sourced to leave a lasting impression.",
        items: [
            {
                id: "prod_leather_01",  
                title: "Leather Goods",
                moq: "50 Units",
                priceRange: "₹300 - ₹5000",
                materials: ["Leather", "Faux Leather", "Canvas"],
                images: [
                    "https://picsum.photos/seed/leather1/600/600",
                    "https://picsum.photos/seed/leather2/600/600",
                    "https://picsum.photos/seed/leather3/600/600",
                    "https://picsum.photos/seed/leather4/600/600",
                ],
            },
            {
                id: "prod_wooden_02",
                title: "Custom Wooden Gifts",
                moq: "50 Units",
                priceRange: "₹300 - ₹1500",
                materials: ["Teak", "Pine", "Bamboo"],
                images: [
                    "https://picsum.photos/seed/wood1/600/600",
                    "https://picsum.photos/seed/wood2/600/600",
                    "https://picsum.photos/seed/wood3/600/600",
                ],
            },
            {
                id: "prod_bottle_03",
                title: "Bottles & Cups",
                moq: "50 Units",
                priceRange: "₹200 - ₹1000",
                materials: ["Steel", "Copper", "Plastic"],
                images: [
                    "https://picsum.photos/seed/bottle1/600/600",
                    "https://picsum.photos/seed/bottle2/600/600",
                    "https://picsum.photos/seed/bottle3/600/600",
                ],
            },
            {
                id: "prod_flag_04",
                title: "Flags, Scarves & Caps",
                moq: "50 Units",
                priceRange: "₹200 - ₹1000",
                materials: ["Silk", "Cotton", "Polyester"],
                images: [
                    "https://picsum.photos/seed/flag1/600/600",
                    "https://picsum.photos/seed/flag2/600/600",
                    "https://picsum.photos/seed/flag3/600/600",
                ],
            },
        ],
    },
    {
        id: "cat_packaging",
        categoryTitle: "Bags & Packaging",
        categoryDescription: "Sustainable and branded packaging solutions for e-commerce and retail.",
        items: [
            {
                id: "prod_cloth_bags_01",
                title: "Cloth & PU Bags",
                moq: "50 Units",
                priceRange: "₹300 - ₹5000",
                materials: ["Cotton", "Canvas", "Jute", "PU Leather"],
                images: [
                    "https://picsum.photos/seed/bags1/600/600",
                    "https://picsum.photos/seed/bags2/600/600",
                    "https://picsum.photos/seed/bags3/600/600",
                    "https://picsum.photos/seed/bags4/600/600",
                ],
            },
            {
                id: "prod_ecommerce_pkg_02",
                title: "E-commerce Packaging",
                moq: "50 Units",
                priceRange: "₹300 - ₹5000",
                materials: ["Corrugated", "Kraft Paper", "Biodegradable"],
                images: [
                    "https://picsum.photos/seed/packaging1/600/600",
                    "https://picsum.photos/seed/packaging2/600/600",
                    "https://picsum.photos/seed/packaging3/600/600",
                ],
            },
        ],
    },
    {
        id: "cat_ethnic",
        categoryTitle: "Ethnic & Specialty Sourcing",
        categoryDescription: "Authentic Indian craftsmanship and specialized sourcing requests.",
        items: [
            {
                id: "prod_ethnic_leather_01",
                title: "Leather Goods",
                moq: "50 Units",
                priceRange: "₹300 - ₹5000",
                materials: ["Camel Leather", "Vegetable Tanned", "Suede"],
                images: [
                    "https://picsum.photos/seed/ethnichleather1/600/600",
                    "https://picsum.photos/seed/ethnichleather2/600/600",
                    "https://picsum.photos/seed/ethnichleather3/600/600",
                ],
            },
            {
                id: "prod_ethnic_wood_02",
                title: "Custom Wooden Gifts",
                moq: "50 Units",
                priceRange: "₹300 - ₹5000",
                materials: ["Sandalwood", "Rosewood", "Hand Carved"],
                images: [
                    "https://picsum.photos/seed/ethnicwood1/600/600",
                    "https://picsum.photos/seed/ethnicwood2/600/600",
                ],
            },
            {
                id: "prod_ethnic_bottles_03",
                title: "Bottles & Cups",
                moq: "50 Units",
                priceRange: "₹300 - ₹5000",
                materials: ["Copper", "Brass", "Earthenware"],
                images: [
                    "https://picsum.photos/seed/ethnicbottle1/600/600",
                    "https://picsum.photos/seed/ethnicbottle2/600/600",
                ],
            },
            {
                id: "prod_ethnic_flags_04",
                title: "Flags, Scarves & Caps",
                moq: "50 Units",
                priceRange: "₹300 - ₹5000",
                materials: ["Khadi", "Silk", "Pashmina"],
                images: [
                    "https://picsum.photos/seed/ethnicflag1/600/600",
                    "https://picsum.photos/seed/ethnicflag2/600/600",
                    "https://picsum.photos/seed/ethnicflag3/600/600",
                ],
            },
        ],
    },
];